export function saveToSession<T>(key: string, value: T) {
  sessionStorage.setItem(key, JSON.stringify(value));
}

export function loadFromSession<T>(key: string, defaultValue: T): T {
  const stored = sessionStorage.getItem(key);
  if (!stored) return defaultValue;
  try {
    return JSON.parse(stored) as T;
  } catch {
    return defaultValue;
  }
}

export function removeFromSession(key: string) {
  sessionStorage.removeItem(key);
}

export function saveToLocal<T>(key: string, value: T) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function loadFromLocal<T>(key: string, defaultValue: T): T {
  const stored = localStorage.getItem(key);
  if (!stored) return defaultValue;
  try {
    return JSON.parse(stored) as T;
  } catch {
    return defaultValue;
  }
}

export function removeFromLocal(key: string) {
  localStorage.removeItem(key);
}
